<template>
  <div>
      <loader v-if="load"></loader>
    <b-modal id="telegram-send-valid" header-bg-variant="success" centered hide-footer>      
      <div class="d-block">
        {{ success_message }}
      </div>
    </b-modal>
    <b-modal id="telegram-send-not-valid" header-bg-variant="danger" centered hide-footer>
      <div class="d-block">
        {{ error_message }}
      </div>
    </b-modal>

    <b-modal id="telegram-form" header-bg-variant="secondary" centered hide-footer>
      <template #modal-title> 
          <div v-html="params.title">
          </div> 
    </template>
      <div class="d-block">
        <b-form @submit.stop.prevent>
          <label for="lastname">Фамилия*</label>
          <b-form-input
            v-model="params.lastname"
            placeholder="Иванов"
            id="lastname"
            required
            :state="notEmpty(params.lastname)"
          ></b-form-input>

          <label for="firstname">Имя*</label>
          <b-form-input
            v-model="params.firstname"
            placeholder="Иван"
            id="firstname"
            required
            :state="notEmpty(params.firstname)"
          ></b-form-input>

          <label for="patronymic">Отчество*</label>
          <b-form-input
            v-model="params.patronymic"
            placeholder="Иванович"
            id="patronymic"
            required
            :state="notEmpty(params.patronymic)"
          ></b-form-input>

          <label for="phone">Номер телефона*</label>
          <b-form-input
            v-model="params.phone"
            v-mask="'+7 (###) ###-##-##'"
            placeholder="+7 (###) ###-##-##"
            id="phone"
            required
            :state="validPhone(params.phone)"
          ></b-form-input>
          <label for="prelastname">Предыдущая фамилия</label>
          <b-form-input
            v-model="params.prelastname"
            placeholder="Сидоров"
            id="prelastname"
          ></b-form-input>
          <template v-if="params.answers">
            <label for="answer" v-html="params.answercaption"></label>
            <b-form-select
              id="answer"
              v-model="params.answer"
              :options="params.answers"
            ></b-form-select>            
          </template>  
        </b-form>
      </div>
      <b-button class="mt-3" @click="sendTelegram()">Отправить</b-button>
    </b-modal>
  </div>
</template>

<script>
import Authentication from "@/components/pages/Authentication";
import LoaderSend from "@/components/components/LoaderSend";
export default {
  data() {
    return {      
      error_message: "",
      success_message: "",
      load:false,
    };
  },
  props:['params'],
  components:{
      'loader':LoaderSend
  },
  methods: {
    validform() {
      if (this.params.firstname == null) {
        this.params.firstname = "";
      }
      if (this.params.lastname == null) {
        this.params.lastname = "";
      }
      if (this.params.patronymic == null) {
        this.params.patronymic = "";
      }
      if (this.params.phone == null) {
        this.params.phone = "";
      }
      return (
        this.notEmpty(this.params.firstname) &&
        this.notEmpty(this.params.lastname) &&
        this.notEmpty(this.params.patronymic) &&
        this.validPhone(this.params.phone)
      );
    },
    async sendTelegram() {
      this.load=true  
      if (this.validform()) {
        let { data } = await Authentication.sendRequestNotAuth(
        this,
        "/api/v1/sendTelegram",
        "post",
        this.params
      );
        if(data.success){
          this.success_message = "Ваше сообщение отправлено.";
          this.$bvModal.show("telegram-send-valid");    
          this.$bvModal.hide("telegram-form");      
        }else{
          this.error_message =
          "Ошибка при отправке, повторите позднее";
          this.$bvModal.show("telegram-send-not-valid");
        }               
      } else {
        this.error_message =
          "Неверно заполнены поля, проверте правильность заполнения";
        this.$bvModal.show("telegram-send-not-valid");
      }
      this.load=false
      
    },
    notEmpty(val) {
      return val == null ? null : val.length > 0 ? true : false;
    },
    validPhone(val) {
      return val == null ? null : val.length == 18;
    },
  },
};
</script>

<style lang="scss">
</style>